/**
 * 工作台集合
 * created by shmeng: 2022-08-31
*/
import React from "react";
import { connect } from "react-redux";
import DefaultIcon from "Assets/images/workbench_nav/workbench_logo.png";
import "./index.less";
import platform from "Pub/js/platform";
const { base, promptBox, PubSub } = platform;
const { NCMenu, NCDropdown, NCTooltip } = base;
const { Item } = NCMenu;
import DragDropItem from "Components/DragDropItem";
import TooltipText from "Components/TooltipText";
import { toggleEditStatus } from "Store/GridLayout/action";
import { setWorkbenchData } from "Store/appStore/action";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import noviceGuideBench from "Assets/images/noviceGuide/novice-guide-bench.gif";

import { getStore, setStore } from "Pub/js/storageUtils";
const PlaceholderLineStyle = '2px solid #2A8CFA';

class AllBench extends React.Component {
    constructor(props) {
        super(props);
    }

    // 工作台切换
    benchSwitch(bench) {
        const { editable, relateidObj } = this.props;
        if (editable) {
            promptBox({
                color: 'warning',
                title: langCheck('0000PUB-000007'), // 保存
                content: langCheck('0000PUB-000508'), // 您即将离开当前工作台，是否要保存？
                beSureBtnName: langCheck('0000PUB-000007'), // 保存
                cancelBtnName: langCheck('0000PUB-000134'), // 离开
                hasCloseBtn: true,
                beSureBtnClick: () => {
                    PubSub.publish("saveDesktopOutside", {
                        isOtherWay: false,
                        saveCallback: () => {
                            this.benchSwitchNext(bench);
                        },
                    });
                },
                cancelBtnClick: () => {
                    this.benchSwitchNext(bench);
                    if (relateidObj.type === 'is_group') { // 集团管理员应用管理 -> 工作台设置
                        location.hash = '#/';
                        location.reload();
                        return;
                    }
                    this.props.updateHomePage(() => {
                        this.props.toggleEditStatus(false);
                    });
                },
            });
            return;
        }

        this.benchSwitchNext(bench);
    }
    benchSwitchNext(bench) {
        if (bench.active) {return;}

        // console.log('工作台切换：', bench);
        const benchData = [...this.props.benchData];
        benchData.forEach(item => {
            item.active = false;
        });
        bench.active = true;
        this.updateBenchData(benchData);
        this.props.updateHomePage(() => {
            const scrollContainer = document.getElementById('ncWorkbenchHomePage');
            scrollContainer && (scrollContainer.scrollTop = 0); // 滚动到顶部
            PubSub.publish('changeInsideTabActived');
        });
    }

    // 更新工作台数据
    updateBenchData(benchData) {
        this.props.setWorkbenchData(benchData);
        const workbenchNavsCache = getStore('workbenchNavs');
        if (workbenchNavsCache) { // 更新缓存
            setStore('workbenchNavs', benchData);
        }
    }

    // 固定到导航栏
    setFixedBench(bench) {
        const benchData = [...this.props.benchData];
        const fixedBench = benchData.filter(item => item.isfixed);
        const currentBench = _.remove(benchData, item => item.workbenchid === bench.workbenchid)[0];
        currentBench.isfixed = true;
        if (fixedBench.length === 3) { // 替换第三个
            fixedBench[fixedBench.length - 1].isfixed = false;
            benchData.splice(fixedBench.length - 1, 0, currentBench);
        } else {
            benchData.splice(fixedBench.length, 0, currentBench);
        }
        this.setWorkbench(benchData).then(() => {
            this.updateBenchData(benchData);
        });
    }

    // 工作台调整
    setWorkbench(benchData) {
        return new Promise(resolve => {
            Ajax({
                url: '/nccloud/platform/appregister/setworkbenchnavigator.do',
                type: 'post',
                data: benchData.map(item => {
                    return {
                        workbenchid: item.workbenchid,
                        isfixed: item.isfixed ? 'Y' : 'N',
                        isdefault: item.isdefault ? 'Y' : 'N',
                    };
                }),
                success: res => {
                    let { success, data } = res.data;
                    if (success) {
                        resolve();
                    }
                },
            });
        });
    }

    // 设置默认
    setDefaultBench(bench) {
        if (bench.isdefault) {return;}

        const benchData = [...this.props.benchData];
        benchData.forEach(item => {
            item.isdefault = false;
        });
        bench.isdefault = true;
        this.setWorkbench(benchData).then(() => {
            this.updateBenchData(benchData);
        });
    }

    // 渲染下拉菜单项
    renderDropdownItem(item) {
        return <Item key={item.workbenchid} className="dropdown-menu-item">
            <DragDropItem item={item}
                onDragDropChange={this.moveItem.bind(this)}
                onClick={() => { this.benchSwitch(item); }}
                className={`bench-dropdown-item ${item.active ? 'active' : ''} ${item.isdefault ? 'default' : ''}`}
                placeholderLineStyle={PlaceholderLineStyle}
            >
                <i className="iconfont icon-tuozhuai1 icon-drag"></i>
                <div className="item-content">
                    <img className="bench-icon" src={item.image || DefaultIcon}></img>
                    <TooltipText text={item.name} className="item-name" />
                    {
                        item.active && <i className="iconfont icon-xuanzhong icon-active"></i>
                    }
                </div>
                <div className="item-right">
                    {
                        !item.isfixed && <NCTooltip
                            // delay={1500}
                            delayShow={500}
                            delay={1}
                            placement="bottom"
                            overlay={langCheck('0000PUB-000570' /* 固定到导航栏 */)}
                        >
                            <i className="iconfont icon-zhiding icon-set-fixed" onClick={e => { e.stopPropagation(); this.setFixedBench(item); }}></i>
                        </NCTooltip>
                    }
                    <NCTooltip
                        // delay={1500}
                        delayShow={500}
                        delay={1}
                        placement="bottom"
                        overlay={langCheck('0000PUB-000571' /* 设为默认 */)}
                    >
                        <i className="iconfont icon-sheweimoren1 icon-set-default" onClick={e => { e.stopPropagation(); this.setDefaultBench(item); }}></i>
                    </NCTooltip>
                </div>
            </DragDropItem>
        </Item>;
    }

    renderPlaceholderItem() {
        const placeholderItem = {
            workbenchid: 'workbench-placeholder',
            disabled: true,
        };
        return <Item key={placeholderItem.workbenchid} className="dropdown-menu-item item-placeholder">
            <DragDropItem
                item={placeholderItem}
                onDragDropChange={this.moveItem.bind(this)}
                className={`bench-dropdown-item`}
                placeholderLineStyle={PlaceholderLineStyle}
            >
                <div className="placeholder-container"></div>
            </DragDropItem>
        </Item>;
    }

    renderFixedLine() {
        const fixedLineItem = {
            workbenchid: 'workbench-fixed-line',
            disabled: true,
        };
        return <DragDropItem
            item={fixedLineItem}
            onDragDropChange={this.moveItem.bind(this)}
            className='bench-split-line'
            placeholderLineStyle={PlaceholderLineStyle}
        >
            <div className="line"></div>
            {langCheck('0000PUB-000507' /* 固定到导航栏 */)}
            <div className="line"></div>
        </DragDropItem>;
    }

    // 拖拽更换位置
    moveItem({ dragItem, dropItem }) {
        const benchData = [...this.props.benchData];
        const dragIndex = benchData.findIndex(item => item.workbenchid === dragItem.workbenchid);
        if (dropItem.workbenchid === 'workbench-placeholder') { // 当前没有固定的数据
            dragItem = benchData.splice(dragIndex, 1)[0];
            dragItem.isfixed = true;
            benchData.unshift(dragItem);
        } else if (dropItem.workbenchid === 'workbench-fixed-line') { // 分割线
            dragItem = benchData.splice(dragIndex, 1)[0];
            if (dragItem.isfixed) { // 固定区域 => 非固定区域
                dragItem.isfixed = false;
                const dropIndex = benchData.findIndex(item => !item.isfixed);
                benchData.splice(dropIndex, 0, dragItem);
            } else { // 相反
                dragItem.isfixed = true;
                let dropIndex = benchData.findLastIndex(item => item.isfixed);
                if (dropIndex === 2) { // 挤占第三个位置
                    benchData[dropIndex].isfixed = false;
                } else {
                    dropIndex++;
                }
                benchData.splice(dropIndex, 0, dragItem);
            }
        } else {
            const dropIndex = benchData.findIndex(item => item.workbenchid === dropItem.workbenchid);
            dropItem = benchData[dropIndex];
            dragItem = benchData.splice(dragIndex, 1)[0];
            if (dropItem.isfixed) { // 固定到导航栏
                dragItem.isfixed = true;
                const fixedBench = benchData.filter(bench => bench.isfixed);
                if (fixedBench.length === 3) { // 挤占第三个的位置
                    fixedBench[fixedBench.length - 1].isfixed = false;
                }
            } else {
                dragItem.isfixed && (dragItem.isfixed = false);
            }
            benchData.splice(dropIndex, 0, dragItem);
        }
        this.setWorkbench(benchData).then(() => {
            this.updateBenchData(benchData);
        });
    }

    renderBenchItem(bench) {
        const benchItemElement = <div
            className={`bench-item ${bench.active ? 'active' : ''}`}
            onClick={() => this.benchSwitch(bench)}
        >
            <img className="bench-icon" src={bench.image || DefaultIcon}></img>
            <span className="bench-name">{bench.name}</span>
        </div>;
        return <NCTooltip
            placement="bottom"
            overlay={bench.name}
            delayShow={500}
            delay={1}
        >
            {benchItemElement}
        </NCTooltip>;
    }

    render() {
        const { ispreview } = this.props;
        let { benchData } = this.props;
        // console.log('工作台数据', benchData);
        const fixedBench = benchData.filter(item => item.isfixed);
        const others = benchData.filter(item => !item.isfixed);
        const activeBench = benchData.find(item => item.active);
        const maxHeight = 470; // 最多容纳10行
        const itemHeight = 42; // 每行高度
        const menuOthersStyle = {};
        if (benchData.length > 10) {
            menuOthersStyle.overflowY = 'auto';
            // 滚动区域最大高度 = 容纳10行的高度 - 固定数据高度 - 固定区域空壳高度
            menuOthersStyle.maxHeight = maxHeight - fixedBench.length * itemHeight - 37;
        }
        const selectedKeys = activeBench ? [activeBench.workbenchid] : [];
        const menu = (
            <div className={`menu-container`}>
                <NCMenu selectedKeys={selectedKeys} className="menu-fixed">
                    {
                        fixedBench.length
                            ?
                            fixedBench.map(item => this.renderDropdownItem(item))
                            :
                            this.renderPlaceholderItem()
                    }
                    {
                        this.renderFixedLine()
                    }
                </NCMenu>
                <NCMenu selectedKeys={selectedKeys} className="menu-others" style={menuOthersStyle}>
                    {
                        others.length
                            ?
                            <React.Fragment>
                                {others.map(item => this.renderDropdownItem(item))}
                                {/* 底部留白，出现超出滚动的情况下，为保证显示整数个，遮住超出内容 */}
                                {benchData.length > 10 && <div className="menu-leave-blank bottom"></div>}
                            </React.Fragment>
                            :
                            <div className="menu-empty">
                                <div className="empty-img"></div>
                                <div className="empty-text">{langCheck('0000PUB-000579' /* 暂无其他工作台 */)}</div>
                            </div>
                    }
                </NCMenu>
            </div>
        );
        const dataIntro = `
        <img src=${noviceGuideBench} alt="" class='novice-guide-allapps' />
        <p>${langCheck('0000PUB-000572')}</p>
        <div class='span-box'>
            <span>${langCheck('0000PUB-000573')}</span>
        </div>
        <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
        `;

        return <div
            ref={ref => this.allBenchRef = ref}
            className="nc-workbench-all-bench"
            {...(ispreview ? {} : {
                "data-step": "2",
                "data-intro": dataIntro
            })}
        >
            {
                fixedBench.map(bench =>
                    this.renderBenchItem(bench),
                )
            }
            {
                benchData.length > 1 && <NCDropdown
                    getPopupContainer={() => this.allBenchRef}
                    trigger={['click']}
                    overlay={menu}
                    animation="slide-up"
                    overlayClassName="bench-dropdown"
                >
                    <NCTooltip
                        placement="bottom"
                        overlay={!activeBench.isfixed ? activeBench.name : ''}
                        delayShow={500}
                        delay={1}
                    >        
                        <div className={`bench-item bench-more ${!activeBench.isfixed && activeBench.active ? 'active' : ''}`}>
                            {
                                !activeBench.isfixed && <React.Fragment>
                                    <img className="bench-icon" src={activeBench.image || DefaultIcon}></img>
                                    <span className="bench-name">{activeBench.name}</span>
                                </React.Fragment>
                            }
                            <i className="iconfont icon-gengduo"></i>
                        </div>
                    </NCTooltip>
                </NCDropdown>
            }
        </div>;
    }
}
export default connect(
    state => ({
        editable: state.gridLayoutData.editable,
        updateHomePage: state.gridLayoutData.updateHomePage,
        benchData: state.appData.workbenchData,
    }),
    {
        toggleEditStatus,
        setWorkbenchData,
    },
)(AllBench);
